import { ArrowDown, ArrowUp, Pencil, Plus, Trash2 } from "lucide-react";
import { MoreActionsMenu } from "components/common/MoreActionsMenu";
import type { MoreActionsMenuGroup, MoreActionsMenuItem } from "components/common/MoreActionsMenu";
import type { TopSheetRowActionsProps } from "./TopSheetRowActions.types";

const iconClass = "h-4 w-4 shrink-0";

export const TopSheetRowActions = ({
  rowKind,
  onAddSubCategory,
  onRename,
  onMoveUp,
  onMoveDown,
  onDelete,
  canMoveUp = false,
  canMoveDown = false,
  disabled,
  disabledTitle,
}: TopSheetRowActionsProps) => {
  const lockedTitle = disabled ? disabledTitle : undefined;
  const structureItems: MoreActionsMenuItem[] = [];

  if (onRename) {
    structureItems.push({
      id: "rename",
      label: "Rename",
      icon: <Pencil className={iconClass} />,
      disabled,
      title: lockedTitle,
      onSelect: onRename,
    });
  }

  if (rowKind === "category" && onAddSubCategory) {
    structureItems.push({
      id: "add-sub-category",
      label: "Add sub-category",
      icon: <Plus className={iconClass} />,
      disabled,
      title: lockedTitle,
      onSelect: onAddSubCategory,
    });
  }

  if (onMoveUp && onMoveDown) {
    structureItems.push(
      {
        id: "move-up",
        label: "Move up",
        icon: <ArrowUp className={iconClass} />,
        disabled: disabled || !canMoveUp,
        title: lockedTitle,
        onSelect: onMoveUp,
      },
      {
        id: "move-down",
        label: "Move down",
        icon: <ArrowDown className={iconClass} />,
        disabled: disabled || !canMoveDown,
        title: lockedTitle,
        onSelect: onMoveDown,
      }
    );
  }

  const groups: MoreActionsMenuGroup[] = [];

  if (structureItems.length > 0) {
    groups.push({ id: "structure", items: structureItems });
  }

  groups.push({
    id: "destructive",
    items: [
      {
        id: "delete",
        label: "Delete",
        icon: <Trash2 className={iconClass} />,
        variant: "destructive",
        disabled,
        title: lockedTitle,
        onSelect: onDelete,
      },
    ],
  });

  return (
    <MoreActionsMenu
      label={rowKind === "category" ? "Category actions" : "Sub-category actions"}
      align="end"
      disabled={disabled}
      disabledTitle={disabledTitle}
      triggerClassName="h-7 w-7 p-0"
      groups={groups}
      onOpenChange={(open) => {
        if (open) {
          (document.activeElement as HTMLElement | null)?.blur();
        }
      }}
    />
  );
};
